import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { collection, FBaseService } from '../services/firebase/f-base.service';

export const AdminGuard = async (data: any) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const firebaseService = inject(FBaseService);

  let user: any;
  try {
    user = await firstValueFrom(authService.currentUser());

    if (user && user.uid) {
      const fbuser = await firstValueFrom(firebaseService.getById(collection.users, user.uid));

      if (fbuser.role === 'ADMINISTRATOR') {
        return true;
      }
    }
  } catch (error) {
    console.error('Authentication error:', error);
  }
  return router.createUrlTree(['/select-subject']);
};
